import { Injectable } from "@angular/core"
import { ForceDirectedGraph, Link, Node } from "./models"
import * as d3 from "d3"
import { BehaviorSubject } from "rxjs"
import { CHNode } from "../../../models/node.model"

// TODO REMOVE WORDCLOUD

Injectable()
export class D3Service {
    // todo create get methods
    selectedSubject = new BehaviorSubject<CHNode | null>(null)

    constructor() {}

    /** bind a pan and zoom behaviour to an svg element */
    applyZoomableBehaviour(svgElement, containerElement) {
        let svg, container, zoomed, zoom

        svg = d3.select(svgElement)
        container = d3.select(containerElement)

        zoomed = ({ transform }) => {
            container.attr(
                "transform",
                "translate(" + transform.x + "," + transform.y + ") scale(" + transform.k + ")"
            )
        }

        zoom = d3.zoom().on("zoom", zoomed)
        svg.call(zoom)
    }

    /** A method to bind a draggable behaviour to an svg element */
    applyDraggableBehaviour(element, node: Node, graph: ForceDirectedGraph) {
        const d3element = d3.select(element)

        function started(e) {
            /** Preventing propagation of dragstart to parent elements */
            e.sourceEvent.stopPropagation()

            if (!e.active) {
                graph.simulation.alphaTarget(0.3).restart()
            }

            e.on("drag", dragged).on("end", ended)

            function dragged(ev) {
                node.fx = ev.x
                node.fy = ev.y
            }

            function ended(event) {
                if (!event.active) {
                    graph.simulation.alphaTarget(0)
                }

                node.fx = null
                node.fy = null
            }
        }

        d3element.call(d3.drag().on("start", started))
    }

    getForceDirectedGraph(nodes: Node[], links: Link[], options: { width; height }) {
        return new ForceDirectedGraph(nodes, links, options)
    }
}
